import { createSelector } from '@reduxjs/toolkit';
import { selectContactPhone } from 'shared/selectors/jsonQuery';

export const selectContactPhoneFilter = createSelector(selectContactPhone, value => ({
  label: 'Номер телефона',
  value,
}));
